import { Helmet } from "react-helmet-async";
import { siteConfig } from "@/lib/siteConfig";

export function SEO({ title, description, path = "/" }) {
  const fullTitle = "Dulorme Labs™";
  const socialTitle = `Dulorme Labs™ | ${title}`;
  const url = `https://${siteConfig.domain}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={socialTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={siteConfig.legalName} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={socialTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
